<template>
  <div>
    <h3 class="title-page">{{ $t("roles") }}</h3>
    <div class="reference_type_page">
      <div class="admin_container">
        <div class="text-right mb-5">
          <v-btn @click="editItem('add')" color="primary" dark>
            <!--          <v-icon>mdi-plus</v-icon>-->
            {{ $t("create") }}
          </v-btn>
        </div>
        <table-with-filter
          :headers="headers"
          :items="roles"
          hide-default-footer
          :page="configuration.page"
        >
          <template #filter.code>
            <div class="pa-1">
              <custom-input-text
                class="user_input no-margin"
                v-model="configuration.code"
                @input="filterRole"
                clearable
              />
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <template v-if="item.system == 'false'">
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="editItem('update', item)"
                  >
                    <vue-icon icon="newPencilIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->

                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="editItem('delete', item)"
                  >
                    <vue-icon icon="newTrashIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("delete") }}</span>
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->

                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="editItem('add-permission', item)"
                    :to="{
                      name: 'reference-permissions',
                      query: { code: item.code },
                    }"
                  >
                    <vue-icon icon="newPermissionIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("addPermission") }}</span>
              </v-tooltip>
            </template>
            <template v-else>
              <v-chip> System </v-chip>
            </template>
          </template>
        </table-with-filter>

        <vue-pagination
          @update:limit="
            (limit) => {
              configuration.limit = limit;
              configuration.page = 1;
              changePage();
            }
          "
          v-model="configuration.page"
          :length="lastPage"
          @input="changePage"
          max-page
          :limit="configuration.limit"
        />
      </div>

      <!--        modals-->
      <v-dialog v-model="dialog" max-width="500px">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <v-form @submit.prevent="handleSubmit(save)">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
                <v-icon @click="dialog = false" class="info_modal_close"
                  >mdi-close
                </v-icon>
              </v-card-title>

              <v-card-text>
                <div class="edit_user_table">
                  <CustomInputText
                    rules="required"
                    v-model="editedItem.name"
                    :label="`${$t('name')}*`"
                  ></CustomInputText>
                </div>
                <div class="edit_user_table d-flex align-center">
                  <CustomInputText
                    class="flex-grow-1 no-margin"
                    rules="required"
                    v-model="editedItem.code"
                    :label="`${$t('code')}*`"
                  ></CustomInputText>
                  <v-switch
                    :label="$t('additionalRole')"
                    v-model="editedItem.additional"
                    hide-details
                    class="pl-2"
                    dense
                  ></v-switch>
                </div>
              </v-card-text>
              <v-card-actions class="footer_modal_user">
                <v-spacer></v-spacer>
                <v-btn color="#9EABBE" dark @click="close">{{
                  $t("toCancel")
                }}</v-btn>
                <v-btn color="primary" dark type="submit">{{
                  $t("save")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-dialog>
      <warning-dialog
        v-model="deleteModal"
        @apply="deleteItem"
      ></warning-dialog>
    </div>
  </div>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import {
  debounce,
  getValueByKey,
  makerPagination,
  trueSet,
} from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

const ROLE_FORM = {
  id: null,
  name: null,
  code: null,
  additional: false,
  system: false,
};

export default {
  components: { VuePagination, TableWithFilter, WarningDialog },
  data: () => ({
    dialog: false,
    deleteModal: false,
    roles: [],
    editedItemId: null,
    editedItem: {
      ...ROLE_FORM,
    },
    configuration: {
      page: 1,
      limit: "50",
      code: null,
    },
    lastPage: 0,
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("code"),
          value: "code",
        },
        { text: "", value: "actions", sortable: false },
      ];
    },
    formTitle() {
      return this.editedItemId ? this.$t("editGroup") : this.$t("create");
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        const { form } = this.$refs;
        this.editedItem = {
          ...ROLE_FORM,
        };
        if (form) form.reset();
      }
    },
  },

  methods: {
    changePage() {
      this.$router.replace({ query: { ...this.configuration } });
      this.showLoading();
      this.getRoles();
      this.clearLoading();
    },
    filterRole: debounce(async function () {
      await this.$router.replace({ query: { ...this.configuration } });
      this.showLoading();
      await this.getRoles();
      this.clearLoading();
    }, 300),
    editItem(type, item) {
      if (type === "add") {
        this.dialog = true;
      } else if (type === "update") {
        this.editedItemId = item.id;
        this.editedItem = { ...item };
        this.dialog = true;
      } else if (type === "delete") {
        this.editedItem = item;
        this.deleteModal = true;
      }
    },

    close() {
      this.dialog = false;
    },

    async deleteItem() {
      try {
        const { id } = this.editedItem;
        await this.$http.delete("role/delete", {
          params: { id },
        });
        this.editedItem = {
          ...ROLE_FORM,
        };
        this.roles = this.roles.filter((item) => item.id !== id);
        this.setSuccess({ text: this.$t("successfullyDeleted") });
      } catch (e) {
        this.setResponseError({
          error: e,
        });
      }
    },
    async save() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.post("role", this.editedItem);
        if (this.editedItemId) {
          await this.getRoles();
        } else {
          this.roles.push(data);
        }
        this.dialog = false;
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getRoles() {
      const { page, limit, code } = this.configuration;
      const params = {
        page: page - 1,
        limit,
        code,
      };
      try {
        const {
          data: { data: roles, total },
        } = await this.$http.get("role/list", { params });
        this.lastPage = makerPagination({ limit, total }).lastPage;
        this.roles = roles
          .map((role) => getValueByKey(ROLE_FORM, role))
          .map((role) => {
            role.additional = trueSet(role.additional);
            return role;
          });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async created() {
    const options = getValueByKey(this.configuration, this.$route.query);
    if (options.page && !isNaN(options.page)) options.page = +options.page;
    this.configuration = options;

    this.showLoading();
    await this.getRoles();
    this.clearLoading();
  },
};
</script>

<style scoped></style>
